// Mi marca — drawn example figures for the catalog of the collection "YouTube y
// LinkedIn", used only when there is no real photo to show: a flat, waist-up
// silhouette on a transparent background, marked "EJEMPLO". Not a person and not
// a photograph; never exported in a piece (pieces use Ale's photos).

const LOOKS = [
  { skin: '#C9A88C', hair: '#3B2A22', top: '#8A9A8E' },
  { skin: '#B98E6E', hair: '#1F1915', top: '#B9A27A' },
  { skin: '#E0C2A6', hair: '#6B4A33', top: '#9A8478' },
  { skin: '#A97F62', hair: '#2B211C', top: '#7E8A9A' },
];
const cache = new Map();

/** A waist-up example figure (1000 × 1250, transparent around it). */
export function exampleFigure(variant = 0) {
  const v = Math.abs(variant) % LOOKS.length;
  if (cache.has(v)) return cache.get(v);
  const c = document.createElement('canvas');
  c.width = 1000; c.height = 1250;
  const x = c.getContext('2d');
  const look = LOOKS[v];
  // Torso: shoulders to the waist (the lower edge)
  x.fillStyle = look.top;
  x.beginPath();
  x.moveTo(140, 1250); x.lineTo(175, 820);
  x.quadraticCurveTo(195, 690, 360, 650); x.lineTo(640, 650);
  x.quadraticCurveTo(805, 690, 825, 820); x.lineTo(860, 1250); x.closePath(); x.fill();
  // Neck
  x.fillStyle = look.skin;
  x.fillRect(440, 500, 120, 175);
  x.beginPath(); x.ellipse(500, 668, 80, 34, 0, 0, Math.PI); x.fill();
  // Head and hair
  x.fillStyle = look.hair;
  x.beginPath(); x.ellipse(500, 300, 205, 232, 0, 0, Math.PI * 2); x.fill();
  x.fillStyle = look.skin;
  x.beginPath(); x.ellipse(500, 345, 165, 200, 0, 0, Math.PI * 2); x.fill();
  x.fillStyle = look.hair;
  x.beginPath(); x.ellipse(500, 215, 185, 120, 0, Math.PI, Math.PI * 2); x.fill();
  // Label: an example, not a person
  x.fillStyle = 'rgba(255,255,255,0.9)'; x.font = '700 46px Arial'; x.textAlign = 'center';
  x.fillText('EJEMPLO', 500, 1000);
  const out = { img: c, w: 1000, h: 1250, src: c.toDataURL('image/png'), cutout: true, example: true };
  cache.set(v, out);
  return out;
}

/**
 * Whether an image has a transparent background (a cut-out silhouette): enough
 * fully transparent pixels along its border. Read once, on a small copy.
 */
export function hasTransparentEdge(img, w, h) {
  try {
    const s = Math.min(1, 160 / Math.max(w, h));
    const cw = Math.max(2, Math.round(w * s)), ch = Math.max(2, Math.round(h * s));
    const c = document.createElement('canvas');
    c.width = cw; c.height = ch;
    const x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(img, 0, 0, cw, ch);
    const d = x.getImageData(0, 0, cw, ch).data;
    let clear = 0, total = 0;
    const at = (px, py) => { total++; if (d[(py * cw + px) * 4 + 3] < 16) clear++; };
    for (let px = 0; px < cw; px++) { at(px, 0); }
    for (let py = 0; py < ch; py++) { at(0, py); at(cw - 1, py); }
    return clear / total > 0.35;
  } catch { return false; }
}
